import React, { useMemo } from 'react'
import { formatCommonAmount } from '../../../util/formatAmount'
import { formatCommonDate } from '../../../util/formatDateAndTime'
import PackageSummary from '../../../pages/vendors-list/Modals/PackageSummary'
import styles from '../../../pages/vendors-list/vendorsListPage.module.scss'

const SUMMARY_FIELDS = [
	{ key: 'kazooName', heading: 'Wedding Name' },
	{
		key: 'startDate',
		heading: 'Start Date',
		format: (v) => formatCommonDate(v),
	},
	{
		key: 'endDate',
		heading: 'End Date',
		format: (v) => formatCommonDate(v),
	},
	{ key: 'guestCount', heading: 'Guest Count' },
	{
		key: 'budget',
		heading: 'Budget',
		format: (v) => formatCommonAmount(v),
	},
]

function ProposalSummary({ selectedKazoo, setSelectedKazoo, selectedPackage }) {
	const summary = useMemo(() => {
		if (!selectedKazoo || !Object.keys(selectedKazoo).length) return []
		return SUMMARY_FIELDS.map(({ key, heading, format }) => ({
			heading,
			value: selectedKazoo[key]
				? format
					? format(selectedKazoo[key])
					: selectedKazoo[key]
				: '--',
		}))?.filter((item) => item.value !== '--')
	}, [selectedKazoo])

	return (
		<div className={styles.VendorsListModalBody}>
			<div>
				<div className={styles.summary}>
					<h4>Proposals Summary</h4>
					<div className="">
						<ul>
							{summary.map((item) => (
								<li key={item.heading}>
									<span className={styles.heading}>
										{item.heading}
									</span>
									<span className={styles.value}>
										{item.value}
									</span>
								</li>
							))}
						</ul>
						{(selectedPackage?._id || selectedPackage?.name) && (
							<PackageSummary
								selectedPackage={{
									...selectedPackage,
									addOnsIds: selectedPackage.addOns,
									selectedAddOns:
										selectedPackage?.addOns?.map(
											(a) => a._id
										) ?? [],
								}}
							/>
						)}
						<div className={styles.requirements}>
							<p className={styles.heading}>
								Service Requirements
							</p>
							<p className={styles.value}>
								{selectedKazoo?.serviceRequirements || '--'}
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ProposalSummary
